<template>
  <div class="pointer">
    <div
      @mouseover="isHovering = true"
      @mouseout="isHovering = false"
      :class="{ hovering: isHovering }"
    >
      <img
        style="border-radius: 130px"
        class=""
        :src="$_addToUrl(speaker.speakerImageURL, cloudinaryParams)"
        alt=""
      />
      <div class="glitch__layers">
        <div
          :class="[
            isHovering ? 'glitch__layer' : '',
            row2 ? 'glitch-position' : '',
          ]"
          :style="{
            'background-image':
              'url(' +
              $_addToUrl(speaker.speakerImageURL, cloudinaryParams2) +
              ')',
          }"
        ></div>
      </div>
      <div class="glitch__layers">
        <div
          :class="[
            isHovering ? 'glitch__layer' : '',
            row2 ? 'glitch-position' : '',
          ]"
          :style="{
            'background-image':
              'url(' +
              $_addToUrl(speaker.speakerImageURL, cloudinaryParams2) +
              ')',
          }"
        ></div>
      </div>
      <div class="glitch__layers">
        <div
          :class="[
            isHovering ? 'glitch__layer' : '',
            row2 ? 'glitch-position' : '',
          ]"
          :style="{
            'background-image':
              'url(' +
              $_addToUrl(speaker.speakerImageURL, cloudinaryParams2) +
              ')',
          }"
        ></div>
      </div>
      <div class="glitch__layers">
        <div
          :class="[
            isHovering ? 'glitch__layer' : '',
            row2 ? 'glitch-position' : '',
          ]"
          :style="{
            'background-image':
              'url(' +
              $_addToUrl(speaker.speakerImageURL, cloudinaryParams2) +
              ')',
          }"
        ></div>
      </div>
    </div>

    <div class="speaker-info">
      <strong class="text-center"
        >{{ speaker.speakerFirstName }} {{ speaker.speakerLastName }}
        <span
          v-if="activeSpeaker == speaker._id"
          class="material-symbols-outlined"
        >
          collapse_all
        </span>
        <span v-else class="material-symbols-outlined"> expand_all </span>
      </strong>
      <p class="text-center">{{ speaker.workshopName }}</p>
    </div>
  </div>
</template>

<script>
import { helperMethods } from "../mixins/helpers";

export default {
  props: ["speaker", "row2", "activeSpeaker"],
  mixins: [helperMethods],

  data() {
    return {
      cloudinaryParams:
        "e_grayscale/co_rgb:7246C1/w_1100/w_500,h_500,c_crop,g_face,c_thumb,b_rgb:DDDDDD/w_170",
      cloudinaryParams2:
        "e_grayscale/co_rgb:7246C1/w_1100/w_250,h_250,c_crop,g_face,c_thumb,b_rgb:DDDDDD/w_170",
      isHovering: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

@media (max-width: 500px) {
  .speaker-info strong {
    font-size: 0.8rem;
  }
}

.material-symbols-outlined {
  font-size: 17px;
}
.glitch__layers {
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}






</style>


// WEBPACK FOOTER //
// src/components/WorkshopSpeaker.vue